// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { LoadingType } from '../../types/Common';
import { LabReviewsListData, LabReviewsStatisticsData } from '../../types/LabReviewsData';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

interface InitState {
  LabReviewsList: Record<string, LabReviewsListData[]>;
  LabReviewsStatistics: Record<string, LabReviewsStatisticsData>;
  loadingType: LoadingType;
  isLoading: boolean;
  hasMoreReviews: boolean;
  error?: Error;
}

const { getLabReviewsActions } = actionCreatorsList;
export const initialState: InitState = {
  LabReviewsList: {},
  LabReviewsStatistics: {},
  isLoading: true,
  hasMoreReviews: true,
  loadingType: LoadingType.NEW
};

export default function (state = initialState, action: RootAction) {
  switch (action.type) {
    case getType(getLabReviewsActions.request): {
      const { loadingType } = action.payload;

      return {
        ...state,
        isLoading: true,
        loadingType,
        error: undefined
      };
    }
    case getType(getLabReviewsActions.success): {
      const { id, LabReviewsList, LabReviewsStatistics, loadingType } = action.payload;
      const newData =
        loadingType === LoadingType.NEW
          ? LabReviewsList
          : state.LabReviewsList[id].concat(LabReviewsList);
      const hasMoreReviews = LabReviewsList.length > 0;
      return {
        ...state,
        isLoading: false,
        hasMoreReviews,
        LabReviewsList: { [id]: newData },
        LabReviewsStatistics: { [id]: LabReviewsStatistics }
      };
    }
    case getType(getLabReviewsActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }

    default: {
      return state;
    }
  }
}
